import React, { useState, useEffect } from "react";
import "../../Css/ContactUs.css";
import { Link } from "react-router-dom";
function Contactus() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetch("https://api.gkaglobal.org/gkawebsite/admincontact.php")
      .then((response) => response.json())
      .then((result) => {
        if (result.contacts) {
          setData(result.contacts);
        } else {
          setError("Invalid data format");
        }
      })
      .catch((error) => {
        console.error("Fetch Error:", error);
        setError("Error fetching data");
      })
      .finally(() => setLoading(false));
  }, [loading, error]);

  return (
    <>
      <h1 className="h1">Admin Contact</h1>

      <div className="w-full max-w-5xl flex justify-between text-center flex-wrap mx-auto gap-5 sm:gap-20 lg:gap-[250px] gap-y-15">
        {data.length > 0 ? (
          data.map((contact, index) => (
            <div
              key={index}
              className="contact-card flex flex-col w-[50%] sm:w-[40%] lg:w-[30%] min-w-[250px]"
            >
              {/* Title First */}
              {contact.title && (
                <p className="text-lg sm:text-xl lg:text-2xl font-semibold text-gray-600 lg:mb-4">
                  {contact.title}
                </p>
              )}

              {/* Name Below Title */}
              <label className="contact-name text-xl sm:text-2xl lg:text-4xl font-semibold lg:mt-2">
                {contact.name}
              </label>

              {/* Email Below Name */}
              {contact.email && (
                <label className="contact-info text-base sm:text-lg lg:text-2xl flex gap-3 lg:gap-4 lg:mb-3">
                  <i className="bi bi-envelope-fill me-2 icon-style lg:text-3xl"></i>
                  <Link to={`mailto:${contact.email}`} className="hidden-link">
                    {contact.email}
                  </Link>
                </label>
              )}

              {/* Handle Single & Multiple Phone Numbers */}
              {contact.phone ? (
                <label className="contact-info text-base sm:text-lg lg:text-2xl flex gap-1 lg:gap-3">
                  <i className="bi bi-telephone-fill me-2 icon-style lg:text-3xl"></i>
                  <Link to={`tel:${contact.phone}`} className="hidden-link">
                    {contact.phone}
                  </Link>
                </label>
              ) : contact.phones ? (
                contact.phones.map((phone, idx) => (
                  <label
                    key={idx}
                    className="contact-info text-base sm:text-lg lg:text-2xl flex gap-1 lg:gap-3"
                  >
                    <i className="bi bi-telephone-fill me-2 icon-style lg:text-3xl"></i>
                    <Link
                      to={`tel:${phone.split(":").pop().trim()}`}
                      className="hidden-link"
                    >
                      {phone}
                    </Link>
                  </label>
                ))
              ) : null}

              {/* Location at the Bottom */}
              {contact.location && (
                <p className="text-lg text-gray-500">{contact.location}</p>
              )}
            </div>
          ))
        ) : (
          <p className="text-gray-600">No contacts available</p>
        )}
      </div>
    </>
  );
}

export default Contactus;
